import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Button
} from "@mui/material";

export default function PresentationCard({
  name,
  image,
  checked,
  onToggle,
}) {
  return (
    <Card
      onClick={onToggle}
      sx={{
        mt: 3.5,
        
        borderRadius: 3,
        cursor: "pointer",
        position: "relative",
        boxShadow: checked
          ? "0 0 0 2px #2e7d32"
          : "0 4px 12px rgba(0,0,0,0.08)",
        transition: "0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
        },
      }}
    >
      {/* overlay */}
      {checked && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            background: "#2e7d32",
            color: "#fff",
            px: 1.2,
            py: 0.3,
            borderRadius: 2,
            fontSize: 12,
            fontWeight: 600,
            zIndex: 2,
          }}
        >
          ВЫБРАНО
        </Box>
      )}

      <CardMedia
        component="img"
        height="220"
        image={image}
        alt={name}
        sx={{ objectFit: "contain", pt: 1 }}
      />

      <CardContent sx={{ pb: 1.5 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            lineHeight: 1.3,
           
            height: 70,
            
          }}
        >
          {name}
        </Typography>

        <Button
          size="small"
          variant={checked ? "contained" : "outlined"}
          color="success"
          fullWidth
          sx={{ mt: 1 }}
        >
          {checked ? "Выбрано" : "Выбрать"}
        </Button>
      </CardContent>
    </Card>
  );
}
